import { RealTimeEventTypes } from '@/enums/RealTimeEventTypes'
import type { ISessionChangedMessage } from '@/models/Sessions/ISessionChangedMessage'
import { type EventHandler, type IRealtimeEventService, RealTimeEventService } from '@/service/RealTimeEvents/RealTimeEventService'
import { injectable } from 'inversify'

export interface ISessionRealTimeEventService extends IRealtimeEventService {}

@injectable()
export class SessionRealTimeEventService extends RealTimeEventService implements ISessionRealTimeEventService {
  constructor(hub: string = 'session') {
    super(hub)
  }

  buildConnection(): void {
    super.buildConnection()
    this.connection.on('SessionStatusUpdateEventAsync', this.onSessionStatusUpdateEvent.bind(this))
  }

  async onSessionStatusUpdateEvent(sessionChangedMessage: ISessionChangedMessage): Promise<void> {
    this.eventHandlers
      .filter(eh => eh.eventType === RealTimeEventTypes.SessionStatusUpdateEvent)
      .forEach(async (eventHandler: EventHandler<ISessionChangedMessage>) => {
        await eventHandler.handle(sessionChangedMessage)
      })
  }
}
